// Polyfill para inicializar util.types antes de que assert lo requiera
// Esto previene: "Cannot read properties of undefined (reading 'isPromise')"

(function () {
  'use strict';

  // Asegurarse de que util está cargado y tiene la estructura correcta
  var util = require('util/');

  // Verificar que util.types existe
  if (!util.types) {
    // Si no existe, crear una implementación básica
    util.types = {
      isPromise: function isPromise(input) {
        return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
      },
      isRegExp: function isRegExp(value) {
        return value instanceof RegExp;
      }
    };
  }

  // Ahora cargar assert de forma segura
  var assert = require('assert');

  // Exportar para que webpack lo incluya
  module.exports = assert;
})();